import { useMutation } from '@tanstack/react-query';
import { api } from '@app/utils/api';
import { errorHandler } from '@app/utils/errorHandler';
import { IBoeingLifespan } from '@entities/boeing/IBoeingLifespan';
import { IMainIndicatorsFilter } from 'pages/Main/components/Filter';
import { BI_BASE_URL } from '@app/contstants/endpoints';
import { IBoeingIncreaseHashrate } from '@entities/boeing/IBoeingIncreaseHashrate';
import { buildDateParams } from '@app/utils/buildDateParams';

export const fetch = async (filters: IMainIndicatorsFilter): Promise<IBoeingIncreaseHashrate> => {
  const params = buildDateParams(filters);

  const response = await api.get<any>(`${BI_BASE_URL}/boeing/increased/hashrate`, {
    params: {
      manager_ids: filters.managers,
      region: filters.regions,
      tag: filters.tags,
      source: filters.sources,
      coins: filters.coins,
      client_ids: filters.clients,
      accounts: filters.accounts,
      ...params,
    },
  });

  return response.data;
};

export const useBoeingIncreaseHashRate = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: fetch,
    onError: error => errorHandler(error),
  });

  return {
    fetch: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};
